import React from 'react';
import { Alert } from 'react-bootstrap';

interface Props {
  setVisible: (value: boolean) => void;
}

export const SignupAlert = (props: Props) => {
  return (
    <Alert variant="primary" className="m-2" dismissible onClose={() => props.setVisible(false)}>
      Request sent! You will receive an email when you are able to log in.
    </Alert>
  );
};
